import {
  Account,
  buildAccountsApiWithToken,
  ListAndSearchAllAccountsBankConnectionTypeEnum,
  TppWebFormMultibankingApiProviderEnum,
} from "@rentablo/api/apiv1";

export type ImportedAccount = Account & { referenceAccount?: Account };

/**
 * The accounts a connection brought in, each reference account folded into
 * the depot it belongs to rather than listed on its own. finAPI and wealthAPI
 * number their connections independently, so the id alone can match both.
 */
export const loadImportedAccounts = async (
  bankConnectionIds: number[],
  provider: TppWebFormMultibankingApiProviderEnum
): Promise<ImportedAccount[]> => {
  const api = await buildAccountsApiWithToken();
  const { data } = await api.listAndSearchAllAccounts({
    bankConnectionId: bankConnectionIds,
    bankConnectionType: [
      ListAndSearchAllAccountsBankConnectionTypeEnum[provider],
    ],
  });
  const accounts = data.accounts ?? [];

  return accounts
    .filter(
      (account) =>
        !account.depotIds?.length ||
        !accounts.some((a) => account.depotIds?.includes(a.id))
    )
    .map((account) => {
      const referenceAccount = accounts.find(
        (a) => a.id === account.contraAccountId
      );
      return referenceAccount ? { ...account, referenceAccount } : account;
    });
};
